(function () {
    'use strict';

    var module = angular.module('uwAgenda.website');
    module.factory('WebsiteGeneratorService', ['$rootScope', 'GroupPracticeService', 'OnlineBookingLinkGeneratorService', 'HelperService', 'SharedAgendaService', 'OnlineBookingRoles', WebsiteGeneratorServiceFn]);

    /* main task service */
    function WebsiteGeneratorServiceFn($rootScope, GroupPracticeService, OnlineBookingLinkGeneratorService, HelperService, SharedAgendaService, OnlineBookingRoles) {

        var data = {
            currentUser: '',
            baseGroupLink: '',
            basePersonalLink: '',
            groupLinkExtraParameters: '',
            personalLinkExtraParameters: '',
            finalPersonalLink: '',
            finalGroupLink: '',
            allGroupPracticeUsers: [],
            filterData: {
                sharedAgendas: [],
                usersForGroupLinkAndLabelsFilter: [],
                allPossibleLabels: [],
                labelsForPersonalLink: [],
                labelsForGroupLink: [],
                selectedUsersCount: 0,
                selectedLabelsCount: 0,
                selectedLanguage: undefined,
                role: OnlineBookingRoles[0] //patient role
            }
        }
        var service = {
            data: data,
            SetInitialLinkValues: SetInitialLinkValues,
            refreshLinks: refreshLinks,
            setAllPossibleLabelsUnselected: setAllPossibleLabelsUnselected,
            copyPersonalLink: copyPersonalLink,
            copyGroupLink: copyGroupLink
        };
        return service;

        //copy current link
        function copyPersonalLink() {
            HelperService.copyTextToClipboard(data.finalPersonalLink);
        }

        function copyGroupLink() {
            HelperService.copyTextToClipboard(data.finalGroupLink);
        }

        function loadGroupPracticeUsersAndLabels() {
            GroupPracticeService.getGroupPracticeUsers(data.currentUser.id)
                .then(function (users) {
                    data.allGroupPracticeUsers = users;
                    setUsersForGroupLinkAndLabelsFilter();
                    loadLabels();
                });
        }

        function SetInitialLinkValues() {
            data.allGroupPracticeUsers =[];
            clearData();
            // initial value always 'Patient' and language of user 
            data.filterData.role = OnlineBookingRoles[0];
            data.filterData.selectedLanguage = null;
            data.currentUser = SharedAgendaService.currentUser();
            data.filterData.sharedAgendas = SharedAgendaService.data.agendas;
            if (data.currentUser.groupPracticeId) {
                loadGroupPracticeUsersAndLabels();
            }else{
                setUsersForGroupLinkAndLabelsFilter();
                loadLabels();
            }

            loadBaseOnlineBookingLink();
        }

        //request labels for agenda from api
        function loadLabels() {
            // load all grouppractice labels
            if (data.currentUser.groupPracticeId) {
                    OnlineBookingLinkGeneratorService.getGroupLabels(data.currentUser.groupPracticeId).then(function (labels) {
                        data.filterData.allPossibleLabels = labels;
                        setAllPossibleLabelsUnselected();
                        setLabelsInLinks();
                        setLabelsInFilter();
                    });
            }else{
                let userAgenda = data.currentUser.agendaId;
                OnlineBookingLinkGeneratorService.getLabels(userAgenda)
                    .then(function (labels) {
                        data.filterData.allPossibleLabels = labels;
                        setAllPossibleLabelsUnselected();
                        setLabelsInLinks();
                        setLabelsInFilter();
                    });
            }
        }
        
        function setLabelsInFilter(){
            data.filterData.allPossibleLabels.forEach(label => {
                label.showInFilter = label.restrictedRoles.map(role => role.fK_Role).includes(data.filterData.role.value);
            });
        }


        function setUsersForGroupLinkAndLabelsFilter() {
            // always clear before filling up again
            data.filterData.usersForGroupLinkAndLabelsFilter = [];
            // filter users
            data.filterData.sharedAgendas.forEach(agenda => {
                if (agenda.owner.selectedInWebsiteLinkConfiguration) {
                    data.groupLinkExtraParameters += "&aid=" + encodeURIComponent(agenda.agendaGuidBase64Encoded);
                    data.filterData.selectedUsersCount++;
                    data.filterData.usersForGroupLinkAndLabelsFilter.push(agenda.owner);
                }
            });
            
            if (data.allGroupPracticeUsers.length > 0 && data.filterData.selectedUsersCount === 0) {
                data.filterData.usersForGroupLinkAndLabelsFilter = data.allGroupPracticeUsers;
            }else if (data.filterData.selectedUsersCount === 0){
                data.filterData.usersForGroupLinkAndLabelsFilter.push(data.currentUser);
            }
        }
        
        function setLabelsInLinks(){
            // loop through all possible labels and check if selected
            data.filterData.allPossibleLabels.forEach(label => {
                if (label.selected) {
                    let encodedLabelId = window.btoa(`${label.id}`);
                    data.personalLinkExtraParameters += "&label=" + encodeURIComponent(encodedLabelId);
                    data.groupLinkExtraParameters += "&label=" + encodeURIComponent(encodedLabelId);
                    data.filterData.selectedLabelsCount++;
                    data.filterData.labelsForPersonalLink.push(label);
                    data.filterData.labelsForGroupLink.push(label);
                }
            });
            
            // if nothing was selected set the labels based on the users
            if (data.filterData.selectedLabelsCount === 0) {
                data.filterData.labelsForPersonalLink = data.filterData.allPossibleLabels.filter(label => label.fK_Agenda === data.currentUser.agendaId);
                data.filterData.labelsForGroupLink = data.filterData.allPossibleLabels;
            }

            // filter on selected users
            let agendaIdsToBeShown = data.filterData.usersForGroupLinkAndLabelsFilter.map(x => x.agendaId);
            // filter labels based on selected users
            data.filterData.labelsForGroupLink = data.filterData.labelsForGroupLink.filter(label => {
                if (agendaIdsToBeShown.includes(label.fK_Agenda)) {
                    return label;
                }
            });

            //filter selected role
            data.filterData.labelsForPersonalLink = data.filterData.labelsForPersonalLink.filter(label => label.restrictedRoles.map(role => role.fK_Role).includes(data.filterData.role.value));
            data.filterData.labelsForGroupLink = data.filterData.labelsForGroupLink.filter(label => label.restrictedRoles.map(role => role.fK_Role).includes(data.filterData.role.value));

        }

        //request baselinks from API
        function loadBaseOnlineBookingLink() {
            let ownerId = data.currentUser.id;

            let agendaId = data.currentUser.agendaId;
            OnlineBookingLinkGeneratorService.getBaseWeblink(ownerId, agendaId, false)
                .then(function (url) {
                    data.basePersonalLink = url.url;
                    if (data.finalPersonalLink === "") {
                        data.finalPersonalLink = url.url;
                    }
                    refreshLinks();
                });
            OnlineBookingLinkGeneratorService.getBaseWeblink(ownerId, agendaId, true)
                .then(function (url) {
                    data.baseGroupLink = url.url;
                    if (data.finalGroupLink === "") {
                        data.finalGroupLink = url.url;
                    }
                    refreshLinks();
                });
        }

        //add selected propperty to the labels
        function setAllPossibleLabelsUnselected() {
            data.filterData.allPossibleLabels.forEach(label => {
                label.selected = false;
            });
        }
        
        function SetLanguageInLink(){
            if (data.filterData.selectedLanguage)
            {
                let encodedLanguage = window.btoa(`${data.filterData.selectedLanguage.isoLangCode}`);
                data.personalLinkExtraParameters += "&language=" + encodeURIComponent(encodedLanguage);
                data.groupLinkExtraParameters += "&language=" + encodeURIComponent(encodedLanguage);
            }
        }

        function SetRoleInLink(){
            if (data.filterData.role)
            {
                let encodedLanguage = window.btoa(`${data.filterData.role.value}`);
                data.personalLinkExtraParameters += "&role=" + encodeURIComponent(encodedLanguage);
                data.groupLinkExtraParameters += "&role=" + encodeURIComponent(encodedLanguage);
            }
        }
        
        function clearData(){
            data.personalLinkExtraParameters = '';
            data.groupLinkExtraParameters = '';
            data.filterData.selectedLabelsCount = 0;
            data.filterData.selectedUsersCount = 0;

            data.filterData.labelsForPersonalLink = [];
            data.filterData.labelsForGroupLink = [];
            data.filterData.usersForGroupLinkAndLabelsFilter = [];
        }

        function refreshLinks() {
            clearData();
            setUsersForGroupLinkAndLabelsFilter();
            setLabelsInFilter();
            setLabelsInLinks();
            SetLanguageInLink();
            SetRoleInLink();

            if (data.basePersonalLink !== "") {
                data.finalPersonalLink = data.basePersonalLink + data.personalLinkExtraParameters;
            }
            if (data.baseGroupLink !== "" ) {
                data.finalGroupLink = data.baseGroupLink + data.groupLinkExtraParameters;
            }
        }
    }
})();